import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 5.5C6.05964 5.5 5.5 6.05964 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H17.25C17.9404 18.5 18.5 17.9404 18.5 17.25V6.75C18.5 6.05964 17.9404 5.5 17.25 5.5H6.75ZM4 6.75C4 5.23122 5.23122 4 6.75 4H17.25C18.7688 4 20 5.23122 20 6.75V17.25C20 18.7688 18.7688 20 17.25 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19253 10.2483C8.46962 9.94039 8.94384 9.91543 9.25172 10.1925L11.7517 12.4425C11.9098 12.5848 12 12.7874 12 13C12 13.2126 11.9098 13.4152 11.7517 13.5575L9.25172 15.8075C8.94384 16.0846 8.46962 16.0596 8.19253 15.7517C7.91543 15.4438 7.94039 14.9696 8.24828 14.6925L10.1289 13L8.24828 11.3075C7.94039 11.0304 7.91543 10.5562 8.19253 10.2483Z"
      fill="currentColor"
    />
  </SvgIcon>
));
